import React, { useState } from 'react';
import { ReactComponent as ArrowDown } from '../../assets/icons/arrow_down.svg';
import { ReactComponent as ArrowUp } from '../../assets/icons/arrow_up.svg';
import { Link } from 'react-router-dom';
import ContactModal from '../contactModal/ContactModal';
import { useLanguage } from '../../context/LanguageContext';
import { footerTemplateTranslations, FooterTranslationKey } from '../../translations/footerTemplate';
import './Footer.css';

type FooterLink = {
  id: FooterTranslationKey;
  path: string;
  isModal?: boolean;
  onClick?: () => void;
};

type FooterSection = {
  title: FooterTranslationKey;
  items: FooterLink[];
};

const Footer: React.FC = () => {
  const { language } = useLanguage();
  const t = footerTemplateTranslations[language];
  const [expandedSections, setExpandedSections] = useState<string[]>([]);
  const [isContactModalOpen, setIsContactModalOpen] = useState(false);

  const footerSections: FooterSection[] = [
    {
      title: 'customerCare',
      items: [
        {
          id: 'contactUs',
          path: '#',
          isModal: true,
          onClick: () => setIsContactModalOpen(true)
        }
      ],
    },
    {
      title: 'ourCompany',
      items: [
        { id: 'findStore', path: '/stores/stores' }
      ],
    },
    {
      title: 'legalArea',
      items: [
        { id: 'imprint', path: '/imprint' }
      ],
    },
  ];

  const toggleSection = (title: FooterTranslationKey) => {
    setExpandedSections((prev) =>
      prev.includes(title)
        ? prev.filter((section) => section !== title)
        : [...prev, title]
    );
  };

  const isSectionExpanded = (title: string) => expandedSections.includes(title);

  return (
    <>
      <footer className="footer mt-12">
        {footerSections.map((section) => (
          <div key={section.title} className="footer-section">
            <h4
              className={`footer-sub-title ${isSectionExpanded(section.title) ? 'active' : ''}`}
              onClick={() => toggleSection(section.title)}
            >
              {t[section.title]}
              <span className="footer-arrow">
                {isSectionExpanded(section.title) ? <ArrowUp className='footer-arrow-up' /> : <ArrowDown />}
              </span>
            </h4>
            <div className={`footer-content ${isSectionExpanded(section.title) ? 'expanded' : ''}`}>
              {section.items.map((item) => (
                item.isModal ? (
                  <div
                    key={item.id}
                    onClick={item.onClick}
                    className="block cursor-pointer"
                  >
                    <p>{t[item.id]}</p>
                  </div>
                ) : (
                  <Link key={item.id} to={item.path} className="block">
                    <p>{t[item.id]}</p>
                  </Link>
                )
              ))}
            </div>
          </div>
        ))}

        <div className='footer_black_bg mt-6'>
        </div>
      </footer>
      <ContactModal
        isOpen={isContactModalOpen}
        onClose={() => setIsContactModalOpen(false)}
      />
    </>
  );
};

export default Footer;